import React from 'react';
import { Check } from 'lucide-react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import laptopWoman from '../../../../assets/images/LaptopWoman.png';
import { Button } from '@/components/ui/button';

const BenefitsSection = () => {
  const history = useHistory();
  const benefits = [
    {
      title: 'Greitesnis registracijos procesas',
      description:
        'Registruokitės ar atšaukite vizitus vos keliais paspaudimais, be papildomų duomenų pildymo.',
    },
    {
      title: 'Asmeninė sveikatos istorija',
      description:
        'Lengvai pasiekite savo tyrimų rezultatus ir vizitų istoriją.',
    },
    {
      title: 'Lojalumo nuolaidos',
      description:
        'Pacientų lojalumo programos nuolaidos taikomos tik prisijungus prie paskyros.',
    },
  ];

  return (
    <section className="bg-[#F9FCFF] w-full py-12 md:py-20">
      {/* Title */}
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-[42px] font-semibold text-[#2A4374]">
          Dar neturite paskyros Affidea pacientų portale?
        </h2>
        <div className="w-30 h-0.5 bg-[#5180CA] mt-3 mx-auto" />
      </div>

      {/* Image + Benefits */}
      <div className="max-w-screen-xl mx-auto px-4 flex flex-col md:flex-row items-center justify-center gap-10 mb-10">
        {/* Benefits (left-aligned always) */}
        <div className="max-w-xl w-full text-left">
          <ul className="space-y-5">
            {benefits.map((item, index) => (
              <li key={index} className="flex items-start gap-3">
                <div className="bg-green-500 rounded-full w-6 h-6 flex items-center justify-center shrink-0 mt-1">
                  <Check className="text-white w-4 h-4" strokeWidth={3} />
                </div>
                <div>
                  <p className="text-[#2A4374] font-semibold">{item.title}</p>
                  <p className="text-gray-500 text-sm">{item.description}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Image (first on desktop, second on mobile) */}
        <div className="md:order-first">
          <img
            src={laptopWoman}
            alt="Laptop user"
            className="w-full aspect-square md:w-[224px] md:h-auto object-cover object-bottom rounded-lg"
          />
        </div>
      </div>

      {/* Button */}
      <div className="text-center">
        <Button
          onClick={() => history.push('/register')}
        >
          KURTI PASKYRĄ
        </Button>
      </div>
    </section>
  );
};

export default BenefitsSection;
